<template>
  <div>
    <ed-email :intId="$route.params.intId" :key="$root.$session.versao"/>
  </div>
</template>

<script>
import EdEmail from "@/components/configuracoes/importacao/editar";

export default {
  name: "pageCadastroEmpresa",
  props: {},
  components: {EdEmail },
  mounted() {
    if(!this.$route.params.intId){
      this.$router.push({ name: "configuracoes.importacao.register" });
    }
  },
  created() {},
  data() {
    return {
    };
  },
  methods: {
  
  },
};
</script>